<template>
  <div class="presentation-controls" @mousemove="mouseMove" @click="play">
    <div class="close" @click.stop="close" v-show="controlsShown">
      退出PPT演示
    </div>
    <div class="footer" v-show="controlsShown" @click.stop>
      <div class="middle-container">
        <div class="previous step" :class="{disabled: previousDisabled}" @click.stop="playPreviousScene">
          <i class="iconfont iconqiehuan-zuo1"></i>
        </div>
        <div class="counter" v-if="editor">
          {{(startingScene || 0) + 1}} / {{editor.scenes.length}}
        </div>
        <div class="next step" :class="{disabled: nextDisabled}" @click.stop="playNextScene">
          <i class="iconfont iconqiehuan-you1"></i>
        </div>
      </div>
      <div class="side-container">
        <div
          class="volume"
          :class="{expanded: volumeRangeShown}"
          @mouseenter="volumeRangeShown = true"
          @mouseleave="mouseLeaveVolume"
        >
          <div class="volume-btn">
            <i class="iconfont iconyinliang4"></i>
          </div>
          <div class="volume-range" v-if="volumeRangeShown">
            <div class="volume-range-content">
              <volumeRange
                v-model="volume"
                :min="0"
                :max="100"
                @endMove="endMoveVolume"
                ref="volumeRange"
              ></volumeRange>
            </div>
          </div>
        </div>
        <div v-if="IsDraftShareShown" class="link" @click.stop="linkPreview">
          <i class="iconfont iconlianjie"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import volumeRange from './presentation/volumeRange.vue';

export default {
  components: {
    volumeRange
  },
  data () {
    return {
      controlsShown: false,
      tid: null,
      sceneQueue: [],
      startingScene: 0,
      volumeRangeShown: false,
      volume: 50,
      didMouseLeaveVolume: false,
      markedTime: 0
    }
  },
  computed: {
    ...mapGetters({
      editor: 'previewTool/editor',
      previewReady: 'previewTool/loaded',
      IsPrivateDraft: 'IsPrivateDraft',
      WorksProjectId: 'WorksProjectId',
      WorksTemplateIds: 'WorksTemplateIds',
      IsDraftShareShown: 'IsDraftShareShown'
    }),
    currentSceneIndex () {
      return (this.editor || {}).currentSceneIndex || void 0;
    },
    previousDisabled () {
      return this.startingScene <= 0;
    },
    nextDisabled () {
      if (!this.editor) {
        return true;
      }
      return this.startingScene >= this.editor.scenes.length - 1
    }
  },
  watch: {
    previewReady (val) {
      if (val) {
        this.initVolume();
        this.createSceneQueue();
        this.play();
      }
    },
    'editor.nowTime' (val) {
      if (!this.editor.isPlay) return;
      if (val >= this.sceneQueue[this.startingScene].end - 2 / 30) {
        this.editor.play({isPlay: false, time: this.sceneQueue[this.startingScene].end - 1 / 30});
      }
    },
    currentSceneIndex (val) {
      console.log(`Turbo ~ currentSceneIndex ~ val`, val)
      if (!this.editor.isPlay) return;
      // this.editor.play({isPlay: false, time: this.sceneQueue[val].end});
    }
  },
  created () {
    this.bindKey();
    this.markedTime = Date.now();
    document.body.style.minHeight = '610px';
  },
  beforeDestroy () {
    this.editor.play({isPlay: false, time: 0});
    document.removeEventListener('keydown', this.keyDown);
    this.$store.commit('previewTool/setEditor', null);
    window._preview = null;
    document.body.style.minHeight = null;
  },
  methods: {
    close () {
      this.$store.commit('previewControls/layerShown', false);
      const presentationDuration = Math.round((Date.now() - this.markedTime) / 1000) || 0;
      window.sensors.track('laipicPPTDemonstrationModel', {
        template_id: this.WorksTemplateIds.join(','),
        spent_time: presentationDuration
      });
    },
    mouseMove () {
      clearTimeout(this.tid);
      this.tid = setTimeout(() => {
        this.controlsShown = false;
      }, 2000);
      this.controlsShown = true;
    },
    createSceneQueue () {
      let start = 0;
      let acc = 0;
      const queue = this.editor.scenes.map(v => {
        start = acc;
        acc += v.duration;
        return {
          start,
          end: acc
        }
      });
      this.sceneQueue = queue;
    },
    getCurrentSceneIndex () {
      let index = -1;
      this.editor.scenes.some((v, i) => {
        if (v.show) {
          index = i;
          return true;
        }
      });
      return index;
    },
    play () {
      const editor = this.editor;
      const isPlay = editor.isPlay;
      const qItem = this.sceneQueue[this.startingScene];
      const isEnd = editor.nowTime >= qItem.end;
      this.editor.play({isPlay: !isPlay, time: isEnd ? qItem.start : editor.nowTime});
      this.startingScene = editor.currentSceneIndex;
      // if (isEnd) {
      //   this.startingScene = 0;
      // }
    },
    playNextScene () {
      if (this.startingScene >= this.editor.scenes.length - 1) {
        return;
      }
      this.startingScene += 1;
      this.editor.play({isPlay: true, time: this.sceneQueue[this.startingScene].start + 1 / 20});
    },
    playPreviousScene () {
      if (this.startingScene <= 0) {
        return;
      }
      this.startingScene -= 1;
      this.editor.play({isPlay: true, time: this.sceneQueue[this.startingScene].start});
    },
    linkPreview () {
      this.$modal.show('presentationLink', {
        source: 'PPT演示模式'
      });
    },
    bindKey () {
      document.addEventListener('keydown', this.keyDown);
    },
    keyDown (event) {
      switch (event.keyCode) {
        case 27:
          this.close();
          break;
        case 32:
          this.play();
          break;
        case 37:
          this.playPreviousScene();
          break;
        case 39:
          this.playNextScene();
          break;
      }
    },
    mouseLeaveVolume () {
      const volumeRange = this.$refs.volumeRange;
      if (volumeRange && volumeRange.isMoving) {
        this.didMouseLeaveVolume = true;
        const h = () => {
          this.$el.removeEventListener('mouseup', h);
          this.volumeRangeShown = false;
        }
        this.$el.addEventListener('mouseup', h);
        return;
      }

      this.volumeRangeShown = false;
    },
    initVolume () {
      this.volume = 100;
      this.setVolume(this.volume);
    },
    setVolume (num) {
      this.editor.changePreviewVolume(num);
    },
    endMoveVolume () {
      this.setVolume(this.volume);
    }
  }
}
</script>

<style scoped lang="scss">
.presentation-controls {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  & > .close {
    position: absolute;
    top: 24px;
    left: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 134px;
    height: 40px;
    background: #FFFFFF;
    box-shadow: 0px 10px 20px rgba(90,98,179,0.1);
    opacity: 1;
    border-radius: 4px;
    &:hover {
      background: #EAEAEB;
      cursor: pointer;
    }
  }
  & > .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 74px;
    background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.15) 21%, rgba(0,0,0,0.65) 100%);
  }
}
.middle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  .iconfont {
    font-size: 30px;
  }
  .counter {
    margin-left: 20px;
    margin-right: 20px;
  }
  .step {
    cursor: pointer;
    &:hover {
      opacity: .9;
    }
    &.disabled {
      opacity: .4;
    }
  }
}
.side-container {
  display: flex;
  align-items: center;
  position: absolute;
  right: 32px;
  bottom: 0;
  height: 74px;
  color: #fff;
  .volume {
    position: relative;
    &.expanded {
      .volume-btn {
        background-color: #000;
      }
    }
    &:hover {
      .volume-btn {
        background-color: #000;
      }
    }
    .volume-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      border-radius: 4px;
      .iconfont {
        font-size: 22px;
      }
    }
    .volume-range {
      // display: none;
      position: absolute;
      left: 0;
      bottom: calc(100%);
      width: 32px;
      min-height: 185px;

      z-index: 2;
      .volume-range-content {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        background-color: rgba(#000, .5);
        width: 32px;
        height: 177px;
      }
    }
  }
  .link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    cursor: pointer;
    margin-left: 10px;
    border-radius: 4px;
    .iconfont {
      font-size: 22px;
    }
    &:hover {
      background-color: #000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/draftPreview/PresentationControls.vue